import { env } from 'configs/EnvironmentConfig'
import fetch from 'auth/FetchInterceptor'
import { z } from 'zod'
import { Validate } from './SchemaValidation'

const DomainService = {}

const querySchema = z.object({
  system: z.enum(['include', 'none', 'only']),
})

const domainSchema = z.object({
  name: z.string(),
})

const numberId = z.number()

DomainService.getDomain = id => {
  return fetch({
    url: `${env.DOMAIN_ENDPOINT_URL}/api/domain/${Validate(numberId, id)}`,
    method: 'GET',
  })
}

DomainService.getDomainList = query => {
  const { system } = Validate(querySchema, query)
  return fetch({
    url: `${env.DOMAIN_ENDPOINT_URL}/api/domain?system=${system}`,
    method: 'GET',
  })
}

DomainService.createDomain = data =>
  fetch({
    url: `${env.DOMAIN_ENDPOINT_URL}/api/domain`,
    method: 'POST',
    data: Validate(domainSchema, data),
  })

DomainService.editDomain = (id, data) =>
  fetch({
    url: `${env.DOMAIN_ENDPOINT_URL}/api/domain/${Validate(numberId, id)}`,
    method: 'PUT',
    data: Validate(domainSchema, data),
  })

DomainService.deleteDomain = id =>
  fetch({
    url: `${env.DOMAIN_ENDPOINT_URL}/api/domain/${Validate(numberId, id)}`,
    method: 'DELETE',
  })

export default DomainService
